import type { AuditTrailRow } from '@/types/audit'

/**
 * The rows of a submission's trail that belong to one form field — what the
 * signature menu's "View Audit Log" shows.
 *
 * Form rows carry the field's LABEL as `itemChanged` (see the backend's
 * `formEntryToAuditRow`), so that is what is matched; process and product rows
 * are about other things and are left out.
 */
export function fieldAuditRows(rows: readonly AuditTrailRow[], fieldLabel: string): AuditTrailRow[] {
  return rows.filter(r => r.source === 'form' && r.itemChanged === fieldLabel)
}
